/* bb2.js — Buff Balm site (2026-10). Page behaviors + the REAL Shopify cart (drawer + cart page).
   Cart engine talks to /cart.js, /cart/add.js, /cart/change.js, /cart/update.js. No forms post to /cart/add, so the
   Seal widget never injects. Shipping protection = one hidden product variant, toggled in the cart (line not rendered). */
(function () {
  'use strict';
  if (window.BB2) return;
  var d = document, root = d.documentElement;
  root.classList.add('js');
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };
  var cfgEl = d.getElementById('bb2-cart-config');
  var CFG = cfgEl ? JSON.parse(cfgEl.textContent) : {};
  var PROT = Number(CFG.protVariant || 0), FREE = Number(CFG.freeShipCents || 7500), PROT_DEFAULT = !!CFG.protDefaultOn;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var T = CFG.strings || {};
  var OFF_KEY = 'bb2ProtOff', ON_KEY = 'bb2ProtOn';
  var state = { cart: null, busy: false, adding: false, err: '' };

  function money(c) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: (state.cart && state.cart.currency) || 'USD' }).format(c / 100); }
    catch (e) { return '$' + (c / 100).toFixed(2); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------- page behaviors ---------- */
  var ann = $('.bb2 .ann');
  if (ann && $$('p', ann).length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) setInterval(function () { ann.classList.toggle('alt'); }, 4200);

  var mb = $('#bb2-menu-btn'), mn = $('#bb2-mnav');
  function closeMenu() { if (!mn || !mb) return; mn.classList.remove('open'); root.style.overflow = ''; mb.setAttribute('aria-expanded', 'false'); }
  if (mb && mn) {
    mb.addEventListener('click', function () { var o = mn.classList.toggle('open'); mb.setAttribute('aria-expanded', o); root.style.overflow = o ? 'hidden' : ''; });
    $$('a', mn).forEach(function (a) { a.addEventListener('click', closeMenu); });
  }

  var rv = $$('.bb2 .rv');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    rv.forEach(function (e) { io.observe(e); });
  } else rv.forEach(function (e) { e.classList.add('is-in'); });

  d.addEventListener('click', function (e) {
    var b = e.target.closest('.bb2 .acc-btn'); if (!b) return;
    var p = d.getElementById(b.getAttribute('aria-controls')), o = b.getAttribute('aria-expanded') !== 'true';
    b.setAttribute('aria-expanded', o); if (p) p.classList.toggle('open', o);
  });

  var nums = $('#bb2-nums'), list = $$('#bb2-nums-list li'), shot = $('#bb2-nums-shot');
  function onNums() {
    if (!nums) return;
    var r = nums.getBoundingClientRect(), span = r.height - innerHeight;
    var t = span > 0 ? Math.min(1, Math.max(0, -r.top / span)) : 1;
    list.forEach(function (li, i) { li.classList.toggle('lit', t >= i / list.length - 0.02 && r.top < innerHeight * 0.6); });
    if (shot) shot.style.setProperty('--rise', (60 - 60 * t) + '%');
  }
  var sbar = $('#bb2-sbar'), hero = $('.bb2 .hero, .bb2 .pdp, .bb2 .phead'), ftr = $('.bb2 .ftr'), sbarOff = null;
  function onSbar() {
    if (!sbar) return;
    var past = hero ? hero.getBoundingClientRect().bottom < 80 : scrollY > 400;
    var atEnd = ftr && ftr.getBoundingClientRect().top < innerHeight - 40;
    sbar.classList.toggle('show', past && !atEnd && !(sbarOff && sbarOff()) && !root.classList.contains('bb2-cart-open'));
  }
  var tick = false;
  addEventListener('scroll', function () { if (tick) return; tick = true; requestAnimationFrame(function () { onNums(); onSbar(); tick = false; }); }, { passive: true });
  onNums(); onSbar();

  $$('.bb2 .chip[data-f]').forEach(function (c) {
    c.addEventListener('click', function () {
      $$('.bb2 .chip[data-f]').forEach(function (x) { x.setAttribute('aria-pressed', x === c); });
      var f = c.getAttribute('data-f');
      $$('.bb2 .shop-grid .pcard').forEach(function (p) { p.hidden = !(f === 'all' || p.getAttribute('data-kind') === f); });
    });
  });

  $$('.bb2 .gal').forEach(function (g) {
    var main = $('.gal-stage img', g), stage = $('.gal-stage', g), th = $$('.gthumb', g), cnt = null;
    function cur() { for (var i = 0; i < th.length; i++) if (th[i].getAttribute('aria-selected') === 'true') return i; return 0; }
    function show(i) { if (cnt) cnt.textContent = (i + 1) + ' / ' + th.length; }
    th.forEach(function (t, i) {
      t.addEventListener('click', function () {
        th.forEach(function (x) { x.setAttribute('aria-selected', x === t); });
        main.src = t.getAttribute('data-src'); main.srcset = t.getAttribute('data-srcset') || ''; main.alt = t.getAttribute('data-alt') || '';
        show(i);
      });
    });
    /* F2 2026-10-19: the big photo took taps and did nothing. Tap = next photo, swipe = next / previous. */
    if (stage && th.length > 1) {
      stage.classList.add('gal-stage--multi');
      stage.setAttribute('role', 'button'); stage.setAttribute('tabindex', '0'); stage.setAttribute('aria-label', 'Next photo');
      cnt = d.createElement('span'); cnt.className = 'gal-count'; cnt.setAttribute('aria-hidden', 'true'); stage.appendChild(cnt); show(cur());
      function go(step) { th[(cur() + step + th.length) % th.length].click(); }
      var sx = null, sy = null, swiped = false;
      stage.addEventListener('touchstart', function (e) { var p = e.touches[0]; sx = p.clientX; sy = p.clientY; swiped = false; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sx === null) return; var p = e.changedTouches[0], dx = p.clientX - sx, dy = p.clientY - sy; sx = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) { swiped = true; go(dx < 0 ? 1 : -1); }
      }, { passive: true });
      stage.addEventListener('click', function (e) { if (swiped) { swiped = false; return; } if (e.target.closest('a,button')) return; go(1); });
      stage.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(1); } });
    }
  });

  /* ---------- cart engine ---------- */
  function api(path, body) {
    var o = { credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    if (body) { o.method = 'POST'; o.body = JSON.stringify(body); }
    return fetch(ROOT + path, o).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { throw new Error(j.description || j.message || ('Error ' + r.status)); } return j; });
    });
  }
  function getCart() { return api('cart.js?_=' + Date.now()); }
  function isProt(i) { return PROT && Number(i.variant_id) === PROT; }
  function lines(c) { return c.items.filter(function (i) { return !isProt(i); }); }
  function prot(c) { return c.items.filter(isProt); }
  function count(c) { return lines(c).reduce(function (n, i) { return n + i.quantity; }, 0); }
  function subtotal(c) { return lines(c).reduce(function (n, i) { return n + i.final_line_price; }, 0); }
  function isMember(c) { return lines(c).some(function (i) { return !!i.selling_plan_allocation; }); }
  function wantsProt(c) {
    if (!PROT || !lines(c).length) return false;
    if (isMember(c)) return false; /* D5: never on a cart with a plan line (keeps member free shipping) */
    if (ls(OFF_KEY) === '1') return false;
    return PROT_DEFAULT || ls(ON_KEY) === '1';
  }
  /* bring the protection line in step with the cart; resolves to the final cart */
  function reconcile(c) {
    var has = prot(c), want = wantsProt(c);
    if (want && has.length === 1 && has[0].quantity === 1) return c;
    if (!want && !has.length) return c;
    var up = {}; has.forEach(function (l) { up[l.key] = 0; });
    var p = has.length ? api('cart/update.js', { updates: up }) : Promise.resolve();
    return p.then(function () { return want ? api('cart/add.js', { items: [{ id: PROT, quantity: 1 }] }) : null; }).then(getCart);
  }
  var chain = Promise.resolve();
  function run(fn) {
    state.busy = true; paint();
    chain = chain.then(fn).then(getCart).then(function (c) { if (state.adding) { state.adding = false; state.cart = c; paint(); } return reconcile(c); }).then(function (c) { state.cart = c; state.err = ''; })
      .catch(function (e) {
        state.err = (e && e.message) || T.error || 'Something went wrong. Try again.';
        return getCart().then(function (c) { state.cart = c; }).catch(function () {});
      })
      .then(function () { state.busy = false; state.adding = false; paint(); });
    return chain;
  }
  function sync() { return run(function () {}); }
  function add(variant, qty, plan) {
    var item = { id: Number(variant), quantity: qty || 1 };
    if (plan) item.selling_plan = Number(plan);
    state.adding = true; open();
    return run(function () { return api('cart/add.js', { items: [item] }); });
  }
  function addItems(items) { state.adding = true; open(); return run(function () { return api('cart/add.js', { items: items }); }); }
  /* the membership box: the cart ends up holding exactly the box on the page (a second tap replaces it, never stacks) */
  function setBox(items, quiet, all) {
    state.adding = true; if (!quiet) open();
    return run(function () {
      return getCart().then(function (c) {
        var ids = {}, up = {}, n = 0, member = false;
        items.forEach(function (i) { if (i.selling_plan) { ids[i.id] = 1; member = true; } });
        /* 2026-10-12 optimizer F2: a balm taken OUT of the box since the last try must leave the cart too. "all" = every
           balm the builder offers; their member lines are cleared whether or not they are in the new box. */
        if (member && all) all.forEach(function (id) { ids[id] = 1; });
        c.items.forEach(function (l) { if (ids[l.variant_id] && l.selling_plan_allocation) { up[l.key] = 0; n++; } });
        return n ? api('cart/update.js', { updates: up }) : null;
      }).then(function () { return api('cart/add.js', { items: items }); });
    });
  }
  function change(key, qty) { return run(function () { return api('cart/change.js', { id: key, quantity: qty }); }); }
  function setProt(on) { ls(OFF_KEY, on ? null : '1'); ls(ON_KEY, on ? '1' : null); return sync(); }

  function planLabel(it) {
    var a = it.selling_plan_allocation; if (!a) return T.oneTime || 'One-time';
    return (a.selling_plan && a.selling_plan.name) || 'Subscription';
  }
  function itemsHtml(c) {
    var ln = lines(c);
    if (!ln.length) return '<p class="cart-empty">' + (state.adding ? (T.adding || 'Adding it to your cart.') : (T.empty || 'Nothing in here yet.<br>Pick your fight.')) + '</p>';
    return ln.map(function (it) {
      var t = it.product_title + (it.variant_title && !/default title/i.test(it.variant_title) ? ' · ' + it.variant_title : '');
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      var im = it.image ? '<img src="' + esc(it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160') + '" alt="" width="76" height="76" loading="lazy">' : '';
      return '<div class="citem" data-key="' + esc(it.key) + '"><a href="' + esc(it.url) + '">' + im + '</a><div><b><a href="' + esc(it.url) + '">' + esc(t) + '</a></b><small>' + esc(planLabel(it)) +
        '</small><span class="cq"><button type="button" data-q="' + (it.quantity - 1) + '" aria-label="One less">−</button><span>' + it.quantity +
        '</span><button type="button" data-q="' + (it.quantity + 1) + '" aria-label="One more">+</button></span></div><div><div class="cp">' + was + money(it.final_line_price) +
        '</div><button class="crm" type="button" data-q="0">' + esc(T.remove || 'Remove') + '</button></div></div>';
    }).join('');
  }
  function paint() {
    var c = state.cart;
    $$('.bb2 [data-bb2-cart]').forEach(function (el) {
      el.classList.toggle('is-busy', state.busy);
      if (!c) { if (state.adding) { var b0 = $('[data-cart-items]', el); if (b0) b0.innerHTML = itemsHtml({ items: [] }); var s0 = $('[data-cart-sub]', el); if (s0) s0.textContent = '...'; } return; }
      var n = count(c), sub = subtotal(c), left = Math.max(0, FREE - sub);
      var box = $('[data-cart-items]', el); if (box) box.innerHTML = itemsHtml(c);
      var ship = $('[data-cart-ship]', el);
      if (ship) ship.textContent = (n && isMember(c) && T.shipMember) ? T.shipMember : !n ? (T.shipEmpty || 'Free shipping on orders over $75.') : left > 0 ? money(left) + (T.shipLeft || ' from free shipping.') : (T.shipDone || 'Free shipping. Done.');
      var bar = $('[data-cart-bar]', el); if (bar) bar.style.width = (isMember(c) ? 100 : Math.min(100, sub / FREE * 100)) + '%';
      var st = $('[data-cart-sub]', el); if (st) st.textContent = state.adding && !n ? '...' : money(c.total_price);
      var tg = $('[data-cart-protect]', el); if (tg) { if (!state.busy) tg.checked = prot(c).length > 0; tg.closest('label').hidden = !PROT || !n || isMember(c); }
      var co = $('[data-cart-co]', el); if (co) { if (n && !state.busy) co.removeAttribute('disabled'); else co.setAttribute('disabled', ''); }
      var er = $('[data-cart-err]', el); if (er) { er.textContent = state.err; er.hidden = !state.err; }
    });
    if (c) $$('.bb2 .hdr-count').forEach(function (b) { b.textContent = count(c); });
  }
  function onCartPage() { return !!$('.bb2 [data-bb2-cart-page]'); }
  function open() {
    if (onCartPage()) return;
    root.classList.add('bb2-cart-open'); onSbar(); var x = $('.bb2 .cart-x'); if (x) x.focus();
  }
  function close() { root.classList.remove('bb2-cart-open'); onSbar(); }

  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-bb2-add],[data-bb2-cart-open],[data-bb2-cart-close],.bb2 .citem [data-q]'); if (!t) return;
    if (t.hasAttribute('data-bb2-add')) {
      e.preventDefault();
      if (t.hasAttribute('disabled')) return;
      var b = t.closest('[data-buy]') || (t.getAttribute('data-for') && d.getElementById(t.getAttribute('data-for')));
      if (b) {
        var sub = !!$('.popt.on[data-plan="sub"]', b), q = $('[data-qty]', b);
        add(b.getAttribute('data-variant'), q ? parseInt(q.textContent, 10) : 1, sub ? b.getAttribute('data-plan-id') : null);
      } else add(t.getAttribute('data-variant'), 1, t.getAttribute('data-plan-id'));
    } else if (t.hasAttribute('data-bb2-cart-open')) {
      if (onCartPage()) return;
      e.preventDefault(); closeMenu(); open(); sync();
    } else if (t.hasAttribute('data-bb2-cart-close')) close();
    else { var li = t.closest('.citem'); if (li) change(li.getAttribute('data-key'), Math.max(0, parseInt(t.getAttribute('data-q'), 10))); }
  });
  d.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('.bb2 [data-cart-protect]')) setProt(e.target.checked); });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); closeMenu(); } });
  d.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('.bb2 .cart-co');
    if (f && state.busy) { e.preventDefault(); chain.then(function () { f.submit(); }); }
  });
  addEventListener('pageshow', function (e) { if (e.persisted) sync(); });

  /* ---------- buy boxes (PDP + homepage) ---------- */
  $$('.bb2 [data-buy]').forEach(function (b) {
    var q = $('[data-qty]', b), cta = $('[data-bb2-add]', b), renew = $('.renew', b), pre = b.getAttribute('data-cta') || 'Add to cart —';
    var once = Number(b.getAttribute('data-once')), subp = Number(b.getAttribute('data-sub') || 0);
    function upd() {
      var sub = !!$('.popt.on[data-plan="sub"]', b), u = sub && subp ? subp : once, n = q ? parseInt(q.textContent, 10) : 1;
      if (cta && !cta.hasAttribute('disabled')) cta.textContent = pre + ' ' + money(u * n);
      if (renew) renew.hidden = !sub;
      var sp = d.getElementById('bb2-sbar-price'); if (sp && b.hasAttribute('data-main')) sp.textContent = money(u);
    }
    $$('.popt', b).forEach(function (o) {
      o.addEventListener('click', function () { $$('.popt', b).forEach(function (x) { x.classList.toggle('on', x === o); var i = $('input', x); if (i) i.checked = x === o; }); upd(); });
    });
    $$('[data-step]', b).forEach(function (s) {
      s.addEventListener('click', function () { q.textContent = Math.max(1, Math.min(9, parseInt(q.textContent, 10) + (+s.getAttribute('data-step')))); upd(); });
    });
    upd();
  });

  /* ---------- BUFF BOX builder (membership) ---------- */
  var bx = $('.bb2 [data-bb2-builder]');
  if (bx) (function () {
    var items = $$('.bx-item', bx), chips = $$('.chip[data-cad]', bx), cta = $('[data-bx-cta]', bx), tot = $('[data-bx-total]', bx);
    var disc = $('[data-bx-disc]', bx), minNote = $('[data-bx-min]', bx), cnt = $('[data-bx-count]', bx), gap = $('[data-bx-gap]', bx);
    var MIN = Number(bx.getAttribute('data-min') || 2), MAXQ = 6, cad = 0;
    items.forEach(function (it) { try { it._plans = JSON.parse(it.getAttribute('data-plans') || '[]'); } catch (e) { it._plans = []; } });
    var hasPlans = items.some(function (it) { return it._plans.length > 0; });
    function planFor(it) {
      if (!it._plans.length) return null;
      var m = chips[cad] ? (chips[cad].getAttribute('data-match') || '').toLowerCase() : '';
      var f = m ? it._plans.filter(function (p) { return (p.desc || '').toLowerCase().indexOf(m) > -1; })[0] : null;
      return f || it._plans[cad] || it._plans[0];
    }
    function qty(it) { return parseInt($('[data-bx-qty]', it).textContent, 10) || 0; }
    function upd() {
      var n = 0, sum = 0;
      items.forEach(function (it) {
        var p = planFor(it), unit = p ? p.price : Number(it.getAttribute('data-once')), q = qty(it);
        n += q; sum += q * unit;
        var pe = $('[data-bx-price]', it); if (pe) pe.textContent = money(unit);
        var was = $('[data-bx-was]', it); if (was) was.hidden = !p || p.price >= Number(it.getAttribute('data-once'));
        it.classList.toggle('on', q > 0);
      });
      if (tot) tot.textContent = money(sum);
      if (cnt) cnt.textContent = n;
      var ok = n >= MIN;
      if (cta && !going) {
        if (ok) cta.removeAttribute('disabled'); else cta.setAttribute('disabled', '');
        cta.textContent = (hasPlans ? bx.getAttribute('data-cta') : bx.getAttribute('data-cta-once')) + ' ' + money(sum);
      }
      if (minNote) minNote.hidden = ok;
      if (disc) {
        disc.hidden = !hasPlans || !ok;
        var label = chips[cad] ? chips[cad].textContent.trim().toLowerCase() : '';
        disc.textContent = (bx.getAttribute('data-disc') || '').split('[total]').join(money(sum)).split('[cadence]').join(label);
      }
      if (gap) {
        /* single price vs member price, read from the products on the page (never typed in). Shown only while
           every member price is below every single price, so the line cannot go stale or untrue. */
        var so = [], mo = [];
        items.forEach(function (it) { var p = planFor(it); if (p) { so.push(Number(it.getAttribute('data-once'))); mo.push(p.price); } });
        var rng = function (a) { var lo = Math.min.apply(null, a), hi = Math.max.apply(null, a); return lo === hi ? money(lo) : money(lo) + ' to ' + money(hi); };
        gap.hidden = !so.length || Math.max.apply(null, mo) >= Math.min.apply(null, so);
        if (!gap.hidden) gap.textContent = (gap.getAttribute('data-t') || '').split('[single]').join(rng(so)).split('[member]').join(rng(mo));
      }
      var sp = d.getElementById('bb2-sbar-price'); if (sp && sp.hasAttribute('data-bx')) sp.textContent = money(sum);
    }
    var cw = $('[data-bx-cadence]', bx); if (cw) cw.hidden = !hasPlans;
    chips.forEach(function (c, i) { c.addEventListener('click', function () { cad = i; chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c); }); upd(); }); });
    bx.addEventListener('click', function (e) {
      var s = e.target.closest('[data-bx-step]'); if (!s) return;
      var it = s.closest('.bx-item'), q = $('[data-bx-qty]', it);
      q.textContent = Math.max(0, Math.min(MAXQ, qty(it) + Number(s.getAttribute('data-bx-step')))); upd();
    });
    if (cta) cta.addEventListener('click', function () {
      if (cta.hasAttribute('disabled')) return;
      var list = [];
      items.forEach(function (it) {
        var q = qty(it); if (!q) return;
        var line = { id: Number(it.getAttribute('data-variant')), quantity: q }, p = planFor(it);
        if (p) line.selling_plan = Number(p.id);
        list.push(line);
      });
      if (!list.length || going) return;
      if (direct && hasPlans && coBtn()) { goCheckout(list); return; }
      if (state.busy) { open(); return; } /* one add at a time: a second tap just shows the cart */
      setBox(list, false, allIds());
    });
    function allIds() { return items.map(function (it) { return Number(it.getAttribute('data-variant')); }); }
    /* 2026-10-09 optimizer F4: START THE MEMBERSHIP goes straight to checkout (section setting "direct_checkout").
       The box is added exactly as before (same lines, same plan on each, same protection rule in run/reconcile). Then the
       cart's OWN checkout button is pressed for the visitor, so the form, the checkout_click event and everything after
       it are the ones the cart uses. While the add is in flight the button is disabled and says so (one tap = one box).
       The cart opens instead, as before, when it holds anything besides this box. A failed add stays on the page. */
    var direct = bx.hasAttribute('data-direct'), going = false, goT = null, errEl = $('[data-bx-err]', bx);
    function coBtn() { return $('.bb2 [data-bb2-cart] [data-cart-co]'); }
    function goEnd() {
      going = false; clearTimeout(goT);
      if (cta) { cta.classList.remove('is-going'); cta.removeAttribute('aria-busy'); }
      upd();
    }
    function sameBox(c, list) {
      var ln = lines(c), want = {};
      list.forEach(function (i) { want[i.id] = i.quantity; });
      return c.items.length === ln.length && ln.length === list.length &&
        ln.every(function (l) { return !!l.selling_plan_allocation && want[l.variant_id] === l.quantity; });
    }
    function goCheckout(list) {
      going = true; if (errEl) errEl.hidden = true;
      cta.setAttribute('disabled', ''); cta.setAttribute('aria-busy', 'true'); cta.classList.add('is-going');
      cta.textContent = bx.getAttribute('data-going') || 'Adding your box...';
      setBox(list, true, allIds()).then(function () {
        var c = state.cart, b = coBtn();
        if (state.err || !c || !count(c)) {
          var m = state.err || T.error || 'Something went wrong. Try again.';
          goEnd();
          if (errEl) { errEl.textContent = m; errEl.hidden = false; } else open();
          return;
        }
        if (!b || !sameBox(c, list)) { goEnd(); open(); return; } /* something else is in the cart too: show it */
        /* the store's pixel reports the add (atc) a moment after it lands: give it 0.3 s to get out before the page leaves */
        setTimeout(function () { b.removeAttribute('disabled'); b.click(); }, 300);
        goT = setTimeout(goEnd, 15000); /* if the browser never leaves, give the button back */
      });
    }
    addEventListener('pageshow', function (e) { if (e.persisted && going) goEnd(); }); /* back from checkout */
    /* 2026-10-09 optimizer: the phone bar's button pointed at the top of this builder, so a tap from inside the builder
       threw the visitor back up (seen in 3 recordings). From the builder on it goes FORWARD to the box total + start
       button and is relabeled; once that button is on screen the bar steps aside. Above the builder: unchanged. */
    var sec = bx.closest('section'), sLink = sbar ? $('a.btn', sbar) : null, sIn = sLink ? sLink.getAttribute('data-in-label') : '';
    if (sLink && cta && sec && sec.id && sIn) (function () {
      var u = null; try { u = new URL(sLink.getAttribute('href'), location.href); } catch (e) {}
      if (!u || u.pathname !== location.pathname || u.hash !== '#' + sec.id) return;
      var lab0 = sLink.textContent, was = null;
      function inBx() { var r = sec.getBoundingClientRect(); return r.top < innerHeight * 0.5 && r.bottom > 0; }
      function ctaSeen() { var r = cta.getBoundingClientRect(); return r.top < innerHeight - 96 && r.bottom > 60; }
      function lab() { var v = inBx(); if (v !== was) { was = v; sLink.textContent = v ? sIn : lab0; } }
      sbarOff = ctaSeen;
      addEventListener('scroll', lab, { passive: true }); lab();
      sLink.addEventListener('click', function (e) {
        if (!inBx()) return;
        e.preventDefault();
        var y = cta.getBoundingClientRect().top + scrollY - innerHeight * 0.45;
        try { scrollTo({ top: y, behavior: 'smooth' }); } catch (err) { scrollTo(0, y); }
      });
    })();
    /* photo, name or Details opens that balm's description under its row (steppers are left alone) */
    bx.addEventListener('click', function (e) {
      if (e.target.closest('.stepper')) return;
      var m = e.target.closest('[data-bx-more], .bx-t'); if (!m) return;
      var it = m.closest('.bx-item'), p = it && $('.bx-d', it); if (!p) return;
      var o = p.hidden; p.hidden = !o;
      $$('[data-bx-more]', it).forEach(function (b) { b.setAttribute('aria-expanded', o); });
    });
    var want = (location.search.match(/[?&]add=([^&#]+)/) || [])[1];
    if (want) items.forEach(function (it) { if (it.getAttribute('data-handle') === decodeURIComponent(want) && !qty(it)) $('[data-bx-qty]', it).textContent = 1; });
    upd();
  })();

  /* ---------- 9-card gifts pop-up (join: no email; home: email capture). Shared state bb_gifts. ---------- */
  var G_KEY = 'bb_gifts';
  function gRead() {
    var raw = null;
    try { raw = localStorage.getItem(G_KEY); } catch (e) {}
    if (!raw) { var m = d.cookie.match(/(?:^|; )bb_gifts=([^;]+)/); if (m) raw = decodeURIComponent(m[1]); }
    try { return raw ? JSON.parse(raw) : null; } catch (e) { return null; }
  }
  function gWrite(st) {
    var v = JSON.stringify({ state: st, ts: Date.now() });
    try { localStorage.setItem(G_KEY, v); } catch (e) {}
    try { d.cookie = 'bb_gifts=' + encodeURIComponent(v) + '; path=/; max-age=' + (180 * 86400) + '; SameSite=Lax'; } catch (e) {}
  }
  function gDone() { var g = gRead(); return !!g && g.state === 'done'; }
  function gBlocked() { var g = gRead(); return !!g && (g.state === 'done' || (g.state === 'dismissed' && Date.now() - g.ts < 7 * 86400000)); }
  $$('.bb2 [data-bb2-gifts-in]').forEach(function (el) { el.hidden = !gDone(); });

  var pop = $('.bb2 [data-bb2-giftpop]');
  if (pop) (function () {
    var card = $('.gpop-card', pop), cards = $$('.gc', pop), tpls = $$('template[data-gift]', pop), sum = $('.gsum', pop), status = $('.gifts-status', pop);
    var form = $('[data-gpop-form]', pop), showBtn = $('.gifts-show', pop), picks = 0, done = false, isOpen = false, last = null, sending = false;
    var after = pop.getAttribute('data-email-after') === '1'; /* 2026-10-26 F4: cards first, email after */
    var locked = !!form && !after;
    function setLocked(v) {
      locked = v; pop.classList.toggle('is-locked', v);
      cards.forEach(function (c) { c.disabled = v; }); if (showBtn) showBtn.disabled = v;
      if (!v && form) { form.hidden = true; var ok = $('[data-gpop-ok]', pop); if (ok) { ok.hidden = false; ok.focus(); } }
    }
    function flip(c) {
      if (locked || done || c.classList.contains('is-flipped')) return;
      var t = tpls[picks]; if (!t) return;
      var front = $('.gc-front', c); front.innerHTML = t.innerHTML; front.style.cssText = t.getAttribute('style') || '';
      c.classList.add('is-flipped'); c.setAttribute('aria-pressed', 'true'); c.setAttribute('aria-label', t.getAttribute('data-label') || '');
      picks++;
      if (picks >= tpls.length) finish();
    }
    function finish() {
      done = true; gWrite('done'); pop.classList.add('is-done');
      cards.forEach(function (c) { if (!c.classList.contains('is-flipped')) { c.classList.add('is-rest'); c.disabled = true; c.setAttribute('aria-hidden', 'true'); } });
      if (sum) sum.classList.add('is-on');
      if (after && sum) setTimeout(function () { sum.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 650);
      if (status) status.textContent = pop.getAttribute('data-done') || '';
      $$('.bb2 [data-bb2-gifts-in]').forEach(function (el) { el.hidden = false; });
    }
    cards.forEach(function (c) { c.addEventListener('click', function () { flip(c); }); });
    if (showBtn) showBtn.addEventListener('click', function () {
      var rest = cards.filter(function (c) { return !c.classList.contains('is-flipped'); });
      while (picks < tpls.length && rest.length && !locked) flip(rest.splice(Math.floor(Math.random() * rest.length), 1)[0]);
      var h = $('.gsum h3', pop); if (h) h.focus();
    });
    function open() {
      if (isOpen) return; isOpen = true; last = d.activeElement;
      pop.classList.add('is-open'); root.classList.add('bb2-gpop-open');
      if (form && !after) setLocked(true);
      (form && !after ? $('input', form) : card).focus();
    }
    function close() {
      if (!isOpen) return; isOpen = false;
      pop.classList.remove('is-open'); root.classList.remove('bb2-gpop-open');
      if (!done) gWrite('dismissed');
      if (last && last.focus) last.focus();
    }
    pop.addEventListener('click', function (e) {
      if (e.target === pop || e.target.closest('[data-gpop-close]')) { e.preventDefault(); close(); return; }
      var j = e.target.closest('[data-gpop-join]');
      if (j) { var h = j.getAttribute('href') || ''; close(); if (h.charAt(0) === '#') { e.preventDefault(); var t = d.getElementById(h.slice(1)); if (t) t.scrollIntoView({ behavior: 'smooth' }); } }
    });
    d.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = $$('button, a[href], input', card).filter(function (el) { return !el.disabled && el.getClientRects().length; });
      if (!f.length) { e.preventDefault(); return; }
      if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    /* 2026-10-04: the ad's utm tags + which page the signup came from, saved as Klaviyo profile properties */
    function utmProps() {
      var out = { bb_signup_page: /join/.test(location.pathname) ? 'join' : 'home' };
      try { var q = new URLSearchParams(location.search); ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) { var v = q.get(k); if (v) out['bb_' + k] = v.slice(0, 120); }); } catch (err) {}
      return out;
    }
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault(); if (sending) return;
      var input = $('input', form), msg = $('[data-gpop-msg]', pop), btn = $('button', form), em = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) { msg.textContent = pop.getAttribute('data-bad') || ''; input.focus(); return; }
      msg.textContent = ''; sending = true; btn.disabled = true;
      var body = { data: { type: 'subscription', attributes: { custom_source: (pop.getAttribute('data-source') || 'BB homepage 9-card pop-up') + (after ? ' (email after the cards)' : ''),
        profile: { data: { type: 'profile', attributes: { email: em, properties: utmProps(), subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
        relationships: { list: { data: { type: 'list', id: pop.getAttribute('data-list') } } } } };
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(pop.getAttribute('data-company')), {
        method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2025-04-15' }, body: JSON.stringify(body)
      }).then(function (r) { if (!r.ok) throw new Error('klaviyo ' + r.status); sending = false;
        if (after) { pop.classList.add('is-unlocked'); form.hidden = true; var okm = $('[data-gpop-ok]', pop); if (okm) { okm.hidden = false; okm.focus(); } } else setLocked(false); })
        .catch(function () { sending = false; btn.disabled = false; msg.textContent = pop.getAttribute('data-err') || ''; });
    });
    var skip = /[?&]nopop=1/.test(location.search) || gBlocked();
    if (!skip) {
      var mode = pop.getAttribute('data-mode');
      if (mode === 'join') {
        var seen = null; try { seen = sessionStorage.getItem('bb2-gpop-seen'); sessionStorage.setItem('bb2-gpop-seen', '1'); } catch (e) {}
        if (!seen) open();
      } else {
        var fired = false, go = function () { if (fired || gBlocked() || root.classList.contains('bb2-cart-open')) return; fired = true; open(); };
        var aft = pop.getAttribute('data-after'), ael = aft ? d.getElementById(aft) : null;
        if (ael) {
          /* wait until the visitor has scrolled past the buy box without buying; no timer, nothing over the first screens */
          addEventListener('scroll', function () {
            if (fired || ael.getBoundingClientRect().bottom > 0) return;
            if (state.cart && count(state.cart) > 0) return;
            go();
          }, { passive: true });
        } else {
          setTimeout(go, Number(pop.getAttribute('data-delay') || 6) * 1000);
          addEventListener('scroll', function () { if (scrollY > (d.documentElement.scrollHeight - innerHeight) * 0.4) go(); }, { passive: true });
        }
      }
    }
    window.BB2Gifts = { open: open, close: close };
  })();

  window.BB2 = { sync: sync, open: open, close: close, add: add, addItems: addItems, state: state };
  if ($('.bb2 [data-bb2-cart]')) sync();
})();
